import moment from 'moment'
import React from 'react'

export default function FooterInner() {
    return (
        <footer className=" bg-blue-100 text-blue-800 py-3 px-2">
            <div className="flex flex-wrap justify-center gap-4 text-sm">
                <a className='text-gray-700'>© {moment(Date.now()).format("YYYY")} <a className='text-blue-700' href='https://cubicleeight.com' target='_blank'>Cubicle Eight</a>. All Rights Reserved</a>
            </div>
        </footer>
    )
}
